import React from "react";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { P } from "../../AbstractElements";

/**
 * Параметры рекламной кампании для приложения к договору.
 *
 * Денежных полей здесь нет намеренно: стоимость считает платформа по прайсу,
 * подписант не может назначить её сам.
 */
const AnnexParamsForm = ({ values, formats, keyActions, onChange }) => {
  const setField = (field, value) => onChange({ ...values, [field]: value });

  const toggleFormat = (format) => {
    const current = values.formats || [];
    const next = current.includes(format)
      ? current.filter((f) => f !== format)
      : [...current, format];
    setField("formats", next);
  };

  return (
    <div>
      <Row>
        <Col md={6}>
          <FormGroup>
            <Label className="col-form-label">Название кампании</Label>
            <Input
              type="text"
              value={values.campaign_name || ""}
              onChange={(e) => setField("campaign_name", e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label className="col-form-label">Что рекламируем</Label>
            <Input
              type="text"
              value={values.subject || ""}
              onChange={(e) => setField("subject", e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label className="col-form-label">Начало размещения</Label>
            <Input
              type="date"
              value={values.period_from || ""}
              onChange={(e) => setField("period_from", e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            <Label className="col-form-label">Окончание</Label>
            <Input
              type="date"
              value={values.period_to || ""}
              onChange={(e) => setField("period_to", e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label className="col-form-label">Плановое количество ключевых действий</Label>
            <Input
              type="number"
              min="0"
              value={values.volume || ""}
              onChange={(e) => setField("volume", e.target.value)}
            />
            <P className="text-muted mb-0">
              Оплата идёт за фактические действия. Плановое количество нужно только для
              ориентировочной стоимости, она считается по прайсу платформы.
            </P>
          </FormGroup>
        </Col>
      </Row>

      <FormGroup>
        <Label className="col-form-label">Ключевое действие</Label>
        <Input
          type="select"
          value={values.key_action || ""}
          onChange={(e) => setField("key_action", e.target.value)}
        >
          <option value="">Выберите действие, за которое платите</option>
          {(keyActions || []).map((action) => (
            <option key={action} value={action}>
              {action}
            </option>
          ))}
        </Input>
      </FormGroup>

      <FormGroup>
        <Label className="col-form-label">Форматы размещения</Label>
        <div>
          {(formats || []).map((format) => (
            <div className="form-check" key={format}>
              <Input
                type="checkbox"
                id={`format-${format}`}
                className="form-check-input"
                checked={(values.formats || []).includes(format)}
                onChange={() => toggleFormat(format)}
              />
              <Label className="form-check-label" for={`format-${format}`}>
                {format}
              </Label>
            </div>
          ))}
        </div>
      </FormGroup>

      <FormGroup>
        <Label className="col-form-label">Локации</Label>
        <Input
          type="text"
          placeholder="Через запятую. Пусто — во всех доступных локациях"
          value={(values.locations || []).join(", ")}
          onChange={(e) =>
            setField(
              "locations",
              e.target.value
                .split(",")
                .map((s) => s.trim())
                .filter(Boolean)
            )
          }
        />
      </FormGroup>

      <FormGroup>
        <Label className="col-form-label">Дополнительные условия</Label>
        <Input
          type="textarea"
          rows={3}
          value={values.extra || ""}
          onChange={(e) => setField("extra", e.target.value)}
        />
      </FormGroup>
    </div>
  );
};

export default AnnexParamsForm;
